export const predefinedEnvironments = [
  {
    name: 'Production',
    isDefault: true
  },
  {
    name: 'Sandbox',
    isDefault: false
  }
];
